import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/cacheService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createEvent, createStore } from 'effector';
export function createCache() {
  var add = createEvent({
    name: "add",
    sid: "-mv0qic"
  });
  var reset = createEvent({
    name: "reset",
    sid: "2cn0s9"
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var cache = createStore({}, {
    name: "cache",
    sid: "-u0e4qf"
  }).on(add, function (state, _ref) {
    var key = _ref.key,
        value = _ref.value;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, value));
  }).reset(reset);

  function createCacheContext(key) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var toCacheValue = null;
    var inCacheResult = cache.getState()[key]; // eslint-disable-next-line @typescript-eslint/no-explicit-any

    var beforeValidation = function beforeValidation(rawValue) {
      toCacheValue = rawValue;
      return rawValue;
    };

    var saveCache = function saveCache(parsedValue) {
      add({
        key: key,
        value: toCacheValue
      });
      return parsedValue;
    };

    return {
      beforeValidation: beforeValidation,
      saveCache: saveCache,
      inCacheResult: inCacheResult
    };
  }

  return {
    reset: reset,
    createCacheContext: createCacheContext
  };
}